import React from "react";
import HandleRelics from "../Handle/HandleRelics";

function Relics() {
  return <HandleRelics />;
}

export default Relics;
